import { render, staticRenderFns } from "./ProductPricing.vue?vue&type=template&id=03912f9d&scoped=true&"
import script from "./ProductPricing.vue?vue&type=script&lang=ts&"
export * from "./ProductPricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03912f9d",
  null
  
)

export default component.exports